<template>
    <BaseForm
        class="payment-info"
        @submit="emit('submit')"
    >
        <template
            v-if="$slots.title"
            #title
        >
            <slot name="title" />
        </template>

        <template #content>
            <template v-if="$slots.content">
                <slot name="content" />
            </template>

            <div class="payment-info__membership">
                <div>
                    <span>Lidmaatschap</span>
                    <span>{{ membership }}</span>
                </div>

                <div>
                    <span>Prijs</span>
                    <span>{{ price }}</span>
                </div>

                <div>
                    <span>Startdatum</span>
                    <span>{{ startDate }}</span>
                </div>

                <div>
                    <span>Naam</span>
                    <span>{{ name }}</span>
                </div>

                <div>
                    <span>Adres</span>
                    <span v-html="address" /> <!-- eslint-disable-line -->
                </div>
            </div>
        </template>

        <template #actions>
            <BaseButton
                type="button"
                @click.prevent="emit('backToPrevious')"
            >
                Vorige stap
            </BaseButton>

            <BaseButton
                :disabled="isSubmitting"
                type="submit"
                class="form__submit button--secondary"
            >
                Door naar bevestigen

                <template #after>
                    <BaseIcon icon="arrow-right" />
                </template>
            </BaseButton>
        </template>

        <template
            v-if="!!$slots.errors"
            #errors
        >
            <slot name="errors" />
        </template>
    </BaseForm>
</template>

<script setup lang="ts">
import type { Maybe } from '~/types/craft-schema';

interface Props {
    membership?: Maybe<string>;
    price?: Maybe<string>;
    startDate?: Maybe<string>;
    name?: Maybe<string>;
    address?: Maybe<string>;
    isSubmitting: boolean;
}

withDefaults(defineProps<Props>(), {
    isSubmitting: false,
    membership: undefined,
    price: undefined,
    startDate: undefined,
    name: undefined,
    address: undefined,
});

const emit = defineEmits(['submit', 'backToPrevious']);
</script>

<style lang="less" src="./FormPaymentInfo.less" />
